import React, { useState } from 'react';
import { Box, Divider, Tab, Tabs } from '@mui/material';

export type FuseTabContent = {
  /**
   * Tab index
   */
  index: number;
  /**
   * Tab label
   */
  label: string;
  /**
   * Tab content
   */
  content: React.ReactNode;
};

export type FuseTabsProps = {
  children: FuseTabContent[];
  defaultTab?: number;
  boxProps?: React.ComponentProps<typeof Box>;
};

export const FuseTabs: React.FC<FuseTabsProps> = ({ defaultTab = 0, children, boxProps }) => {
  /** State **/
  const [activeTab, setActiveTab] = useState(defaultTab);

  /** Methods **/
  const handleChange = (_: React.ChangeEvent<unknown>, newValue: number) => {
    setActiveTab(newValue);
  };

  /** Render **/

  return (
    <Box bgcolor="white" flexDirection="column" height="100%" {...boxProps}>
      <Tabs
        className="md-default-theme"
        value={activeTab}
        indicatorColor="secondary"
        variant="fullWidth"
        scrollButtons="auto"
        onChange={handleChange}
      >
        {children.map((tab) => (
          <Tab
            key={tab.index}
            sx={{ flex: 1 }}
            label={
              <Box component="span" className="text-center">
                {tab.label}
              </Box>
            }
          />
        ))}
      </Tabs>
      <Divider />
      <Box sx={{ overflowY: 'auto' }}>{children[activeTab].content}</Box>
    </Box>
  );
};
